export default __webpack_public_path__ + "static/media/AD01PM.30f66d50.jpg";